import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageBus } from '../../services/message/message-bus.service';
import { LinkLabelComponent } from '../core/labels/link-label.component';
import { ToastComponent } from '../core/labels/toast.component';

@Component({
  selector: 'app-sso-error-page',
  imports: [ToastComponent, LinkLabelComponent],
  template: `
    <div class="tw-flex tw-items-center tw-p-6">
      <h2 class="tw-text-[30px] tw-font-bold tw-flex-1 tw-text-center">
        Something went wrong
      </h2>
    </div>
    <div class="tw-flex tw-justify-center tw-flex-col tw-pt-2 tw-pb-2">
      <div class="tw-flex tw-flex-col">
        <div
          class="tw-flex tw-flex-col tw-flex-full tw-justify-center tw-w-[400px] tw-h-[200px] tw-items-center"
        >
          <app-toast type="Error">Single sign-on error</app-toast>
          <div class="tw-py-8">
            Please try again. If you continue to experience this issue, please
            contact
            <app-link-label
              (click)="messageBus.publish('show-technical-support', requestId)"
              >technical support</app-link-label
            >.
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [``],
})
export class SsoErrorPageComponent {
  messageBus = inject(MessageBus);
  requestId = inject(ActivatedRoute).snapshot.queryParams['requestId'];
}
